<div class="modal-content">
  <div class="modal-header pt-5">
    @if (
      titleMsg !== 'Alert!' &&
      titleMsg !== 'Amount Exceeded' &&
      titleMsg !== 'Missing Installments' &&
      titleMsg !== 'Add More Payment'
    ) {
      <h2 class="text-1 fs-4 text-center" style="color: #03c0fc">
        {{ getTranslatedText('QUOTE_TEMPLATE.' + titleMsg) || titleMsg }}
      </h2>
    }
    @if (titleMsg == 'Alert!') {
      <h2 class="text-1 fs-4 text-center" style="color: rgb(236, 51, 51)">
        {{ getTranslatedText('QUOTE_TEMPLATE.' + titleMsg) || titleMsg }}
      </h2>
    }
    @if (titleMsg == 'Amount Exceeded') {
      <h2 class="text-1 fs-4 text-center" style="color: rgb(236, 51, 51)">
        {{ getTranslatedText('QUOTE_TEMPLATE.' + titleMsg) || titleMsg }}
      </h2>
    }
    @if (titleMsg == 'Missing Installments') {
      <h2 class="text-1 fs-4 text-center" style="color: rgb(236, 51, 51)">
        {{ getTranslatedText('QUOTE_TEMPLATE.' + titleMsg) || titleMsg }}
      </h2>
    }
    @if (titleMsg == 'Add More Payment') {
      <h2 class="text-1 fs-4 text-center" style="color: rgb(236, 51, 51)">
        {{ getTranslatedText('QUOTE_TEMPLATE.' + titleMsg) || titleMsg }}
      </h2>
    }
  </div>
  <div class="modal-body bg-gris-1 px-5 text-center">
    <p>
      {{
        getTranslatedText('QUOTE_TEMPLATE.' + ItemsDeleteModule) ||
          ItemsDeleteModule
      }}
    </p>
  </div>
  <div class="modal-footer j-c-center mt-4 pb-4">
    @if (
      titleMsg !== 'Amount Exceeded' &&
      titleMsg !== 'Missing Installments' &&
      titleMsg !== 'Add More Payment'
    ) {
      <button class="btn btn-2 mx-2" (click)="dialogRef.close(false)">
        {{ 'COMMON.No' | translate }}
      </button>
    }
    @if (
      titleMsg !== 'Amount Exceeded' &&
      titleMsg !== 'Missing Installments' &&
      titleMsg !== 'Add More Payment'
    ) {
      <button
        type="submit"
        class="btn btn-1 mx-2"
        (click)="dialogRef.close(true)"
      >
        {{ 'COMMON.YES' | translate }}
      </button>
    }
    @if (
      titleMsg == 'Amount Exceeded' ||
      titleMsg == 'Missing Installments' ||
      titleMsg == 'Add More Payment'
    ) {
      <button
        type="submit"
        class="btn btn-1 mx-2"
        (click)="dialogRef.close(false)"
      >
        {{ 'Ok' | translate }}
      </button>
    }

    @if (
      titleMsg == 'Alert!' &&
      titleMsg !== 'Amount Exceeded' &&
      titleMsg !== 'Missing Installments' &&
      titleMsg !== 'Add More Payment'
    ) {
      <button
        [matTooltip]="'Preview Quote'"
        type="button"
        (click)="viewQuote()"
        class="d-flex gap-2 align-items-center btn btn-1 mx-2 bg-transparent btn-skyblue-s-1"
      >
        <mat-icon class="material-symbols-outlined"> visibility </mat-icon>
      </button>
    }
  </div>
</div>
